import React from "react";
import _ from "lodash";
import AttributeBox from "./AttributeBox";
import AttributeDefinition from "../../domain/AttributeDefinition";
import {canRenderAttributeKey} from "./ItemAttributeRenderUtils";
import ExpandableItemList from "../common/ExpandableItemList";

const MAX_ATTRIBUTE_VALUES = 5;
const WITHDRAWN_ATTRIBUTE_WARNING_TITLE = "This has been withdrawn or rejected by the source and should not be treated as active.";

interface Props {
    definition?: AttributeDefinition;
    value: any;
}

function ItemAttribute(props: Props) {
    if (_.isArray(props.value)) {
        const attributeName = props.definition?.name ?? "attribute";

        return <ExpandableItemList
            items={props.value}
            maxItems={MAX_ATTRIBUTE_VALUES}
            itemKey={(_, index) => `${attributeName}_${index}`}
            renderItem={value => <ItemAttribute definition={props.definition} value={value}/>}
            renderExpandLabel={({totalCount}) => <i>« show all {totalCount} {attributeName} values »</i>}
            renderCollapseLabel={({maxItems}) => <i>« show only {maxItems} {attributeName} values »</i>}
        />;
    }

    /* nezapomenout na podobné formátování v e-mailových šablonách */

    const attributeName = props.definition?.name;

    switch (attributeName) {
        case "sealScore":
            return <AttributeBox value={<>Score: {props.value}</>} showSearch={false}/>;
        case "cvssBaseScore":
            return <AttributeBox value={<>CVSS: {props.value}</>} showSearch={false}/>;
        case "cveId":
            return <AttributeBox value={props.value} href={`https://nvd.nist.gov/vuln/detail/${props.value}`} clipboardText={props.value} attributeName={attributeName} attributeValue={props.value}/>;
        case "rlsa":
            return <AttributeBox value={props.value} href={`https://errata.build.resf.org/${props.value}`} attributeName={attributeName} attributeValue={props.value}/>;
        case "fgIr":
            return <AttributeBox value={props.value} href={`https://fortiguard.fortinet.com/psirt/${props.value}`} attributeName={attributeName} attributeValue={props.value}/>;
        case "ciscoSa":
            return <AttributeBox value={props.value} href={`https://sec.cloudapps.cisco.com/security/center/content/CiscoSecurityAdvisory/${props.value}`} attributeName={attributeName} attributeValue={props.value}/>;
        case "withdrawn":
            if (props.value !== true) {
                return;
            }

            return <AttributeBox
                value={"withdrawn"}
                warningTitle={WITHDRAWN_ATTRIBUTE_WARNING_TITLE}
                color={"red"}
                showSearch={false}
                attributeName={attributeName}
                attributeValue={props.value}
            />;
        default:
            if (canRenderAttributeKey(attributeName ?? "", props.definition)) {
                if (props.definition?.mergeTicket) {
                    return <AttributeBox value={<>{props.value}</>} showSearch={true} attributeName={attributeName} attributeValue={props.value}/>;
                } else {
                    return <AttributeBox value={<>{attributeName}: {props.value}</>} showSearch={false}/>;
                }
            }

            return;
    }
}

export default ItemAttribute;
